import Api from './api';

export const ApiProvider = ({ host, children }) => {
  Api.BASE_URL = host;
  return children;
};

export default ApiProvider;
